import { ShieldCheck, Users, HardHat, MessagesSquare } from 'lucide-react';
import { motion } from 'framer-motion';
import SectionHeading from './SectionHeading';

const reasons = [
  {
    icon: ShieldCheck,
    title: 'Servicio garantizado',
    description: 'Personal confiable, comprometido y capacitado.',
  },
  {
    icon: Users,
    title: 'Cobertura constante',
    description: 'Garantizamos cobertura y baja rotación.',
  },
  {
    icon: HardHat,
    title: 'Protección personal',
    description: 'Equipo de protección para laborar en cada área necesaria.',
  },
  {
    icon: MessagesSquare,
    title: 'Comunicación continua',
    description: 'Mejoras oportunas, adaptación a necesidades y horarios.',
  },
];

const Reasons = () => {
  return (
    <section id="ventajas" className="bg-slate-50 py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHeading
          center
          eyebrow="Confianza operativa"
          title="¿POR QUÉ SOMOS TU MEJOR OPCIÓN?"
        />

        <div className="relative mt-16 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return (
              <motion.div
                key={reason.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.08 }}
                className="border border-slate-200 bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:border-emerald-400"
              >
                <Icon className="text-[#00a7e2]" size={30} />
                <span className="mt-12 block text-xs font-bold text-slate-300">
                  0{index + 1}
                </span>
                <h3 className="mt-3 text-xl font-bold text-[#0A2540]">
                  {reason.title}
                </h3>
                <p className="mt-3 leading-7 text-slate-600 text-justify">
                  {reason.description}
                </p>
              </motion.div>
            );
          })}
        </div>

        <div className="mx-auto -mt-1 w-fit bg-[#0A2540] px-8 py-3 text-sm font-bold tracking-[.24em] text-white">
          CLEAN <span className="text-[#94cf1c]">WORK</span>
        </div>
      </div>
    </section>
  );
};

export default Reasons;